import React from 'react';
import { COMPLIANCE_COLOR } from '../pages/store-details/components/PlanogramComplianceControlCenter';

interface ComplianceLayerLegendProps {
  selectedComplianceLayers: Set<string>;
  planogramStatusMap: Map<number, string>;
  onToggleComplianceLayer: (layer: string) => void;
}

export const ComplianceLayerLegend: React.FC<ComplianceLayerLegendProps> = ({
  selectedComplianceLayers,
  planogramStatusMap,
  onToggleComplianceLayer,
}) => {
  return (
    <div className="flex items-center gap-2">
      {Object.entries(COMPLIANCE_COLOR).map(([key, color]) => {
        const isSelected = selectedComplianceLayers.has(key);
        // Check if any pog item has this compliance status
        const hasItems = [...planogramStatusMap.values()].includes(key);
        const isDisabled = !hasItems;

        return (
          <button
            key={key}
            onClick={() => !isDisabled && onToggleComplianceLayer(key)}
            disabled={isDisabled}
            className={`flex items-center gap-1 transition-opacity ${
              isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:opacity-80'
            }`}
            title={
              isDisabled
                ? `No ${key} items available`
                : `Click to ${isSelected ? 'hide' : 'show'} ${key} items`
            }
          >
            <span
              className="inline-block w-4 h-4 rounded border border-gray-400"
              style={{
                backgroundColor: isSelected && !isDisabled ? color : 'transparent',
                opacity: isDisabled || !isSelected ? 0.3 : 1,
              }}
            />
            <span
              className="text-xs text-gray-700"
              style={{ opacity: isDisabled ? 0.3 : isSelected ? 1 : 0.5 }}
            >
              {key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}
            </span>
          </button>
        );
      })}
    </div>
  );
};
